import * as Scrivito from "scrivito";
import SectionContentWidget from "../../Widgets/SectionContentWidget/SectionContentWidgetClass";
import HeadlineWidget from "../../Widgets/HeadlineWidget/HeadlineWidgetClass";
import {
  defaultPageInitialContent,
  defaultPageProperties,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("TrainingCatalogPage", {
  title: "Weiterbildungskatalog",
  // hideInSelectionDialogs: true,
  attributes: {
    title: { title: "Title" },
    introduction: { title: "Introduction" },
    body: { title: "Content" },
  },
  properties: [...defaultPageProperties],
  propertiesGroups: [
    {
      title: "Katalog",
      properties: ["introduction"],
    },
  ],

  initialContent: {
    ...defaultPageInitialContent,
    title: "Training Catalog",
    body: [
      new SectionContentWidget({
        content: [new HeadlineWidget({ style: "h1" })],
      }),
    ],
  },
});
